<ng-container *ngTemplateOutlet="phxHasError ? errorTemplate : prefixTemplate"></ng-container>
<ng-template #prefixTemplate>
  <div class="phx-overview-prefix-label-container">
    <span class="phx-overview-prefix-label">{{ phxLabel }}</span>
  </div>
  <div class="phx-overview-prefix-value-subtext-wrapper">
    <div class="phx-overview-prefix-value-container">
      <span class="phx-overview-prefix-value">{{ phxValue }}</span>
      <ng-container *ngIf="changeType !== 'no-change'">
        <div class="phx-overview-prefix-change-wrapper" [ngClass]="getChangeContainerClass()">
          <i phx-icon [phxIcon]="arrowIcon" color="currentColor" [size]="arrowSize"></i>
          <span class="phx-overview-prefix-change">{{ absoluteChangeValue }}</span>
        </div>
      </ng-container>
    </div>
    <div class="phx-overview-prefix-subtext-container">
      <span class="phx-overview-prefix-subtext" *ngIf="phxSubtext">{{ phxSubtext }}</span>
    </div>
  </div>
</ng-template>
<ng-template #errorTemplate>
  <div class="phx-overview-prefix-error-container">
    <i phx-icon [phxIcon]="CircleExclamation" color="currentColor"></i>
    <span class="phx-overview-prefix-error-message">{{ phxErrorMessage }}</span>
  </div>
</ng-template>
